import type { LucideProps } from 'lucide-react';
import {
  Activity,
  AlertCircle,
  AlertTriangle,
  Apple,
  ArrowLeft,
  ArrowRight,
  ArrowUpDown,
  BookOpen,
  Brain,
  Briefcase,
  Building2,
  Calendar,
  Check,
  CheckCircle,
  CheckCircle2,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  Circle,
  Clock,
  Compass,
  Component,
  Copy,
  Download,
  Edit,
  EllipsisVertical,
  ExternalLink,
  FileQuestion,
  FileText,
  Filter,
  Flame,
  FolderPlus,
  Globe,
  GraduationCap,
  GripVertical,
  Headphones,
  Heart,
  Home,
  ImagePlus,
  Info,
  Languages,
  LayoutGrid,
  Leaf,
  Library,
  LifeBuoy,
  Lightbulb,
  ListTodo,
  Loader2,
  LogOut,
  MapPin,
  Maximize,
  Menu,
  MessageCircle,
  MessageSquare,
  MessageSquareText,
  Minimize,
  Minus,
  Monitor,
  Moon,
  MoreHorizontal,
  MoreVertical,
  Mountain,
  Music,
  Package,
  Palette,
  Pause,
  Pencil,
  Play,
  Plus,
  Quote,
  RefreshCw,
  Repeat,
  RotateCcw,
  Save,
  Search,
  Send,
  Settings,
  Settings2,
  Shield,
  ShieldX,
  SkipBack,
  SkipForward,
  Smartphone,
  Smile,
  Sparkles,
  Square,
  Star,
  Sun,
  Sunrise,
  Tags,
  Target,
  Trash2,
  TreePine,
  TrendingDown,
  TrendingUp,
  TriangleAlert,
  Type,
  Upload,
  Users,
  Waypoints,
  X,
  Zap,
} from 'lucide-react';

import {
  LifeCategoryCareer,
  LifeCategoryFamily,
  LifeCategoryFinance,
  LifeCategoryHealth,
  LifeCategoryLove,
  LifeCategoryPersonalDevelopment,
  LifeCategoryRecreation,
  LifeCategorySocial,
} from './LifeCategoryIcons';
import { SpinnerIcon } from './SpinnerIcon';

const iconMap: Record<string, React.ComponentType<LucideProps> | React.ComponentType> = {
  Activity,
  AlertCircle,
  AlertTriangle,
  Apple,
  ArrowLeft,
  ArrowRight,
  ArrowUpDown,
  BookOpen,
  Brain,
  Briefcase,
  Building2,
  Calendar,
  Check,
  CheckCircle,
  CheckCircle2,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  Circle,
  Clock,
  Compass,
  Component,
  Copy,
  Download,
  Edit,
  EllipsisVertical,
  ExternalLink,
  FileQuestion,
  FileText,
  Filter,
  Flame,
  FolderPlus,
  Globe,
  GraduationCap,
  GripVertical,
  Headphones,
  Heart,
  Home,
  ImagePlus,
  Info,
  Languages,
  LayoutGrid,
  Leaf,
  Library,
  LifeBuoy,
  Lightbulb,
  ListTodo,
  Loader2,
  LogOut,
  MapPin,
  Maximize,
  Menu,
  MessageCircle,
  MessageSquare,
  MessageSquareText,
  Minimize,
  Minus,
  Monitor,
  Moon,
  MoreHorizontal,
  MoreVertical,
  Mountain,
  Music,
  Package,
  Palette,
  Pause,
  Pencil,
  Play,
  Plus,
  Quote,
  RefreshCw,
  Repeat,
  RotateCcw,
  Save,
  Search,
  Send,
  Settings,
  Settings2,
  Shield,
  ShieldX,
  SkipBack,
  SkipForward,
  Smartphone,
  Smile,
  Sparkles,
  Square,
  Star,
  Sun,
  Sunrise,
  Tags,
  Target,
  Trash2,
  TreePine,
  TrendingDown,
  TrendingUp,
  TriangleAlert,
  Type,
  Upload,
  Users,
  Waypoints,
  X,
  Zap,
  // Life category icons
  LifeCategoryCareer,
  LifeCategoryFamily,
  LifeCategoryFinance,
  LifeCategoryHealth,
  LifeCategoryLove,
  LifeCategoryPersonalDevelopment,
  LifeCategoryRecreation,
  LifeCategorySocial,
  // Custom icons
  spinner: SpinnerIcon,
};

export type IconName = keyof typeof iconMap;

type Props = {
  iconName: string;
  className?: string;
};

export const Icon = ({ iconName, className }: Props) => {
  const Component = iconMap[iconName];

  if (!Component) {
    return null;
  }

  return (
    <span className={`flex shrink-0 ${className ?? ''}`}>
      <Component className={className} />
    </span>
  );
};
